import React from 'react';
import { Trans } from '@lingui/react/macro';

interface NoProfilesMessageProps {}

const NoProfilesMessage: React.FC<NoProfilesMessageProps> = (props) => {
    //Need better text here
    return (
        <h1 style={{ textAlign: 'center' }}>
            <Trans>You have no profiles</Trans>
        </h1>
    );
};

export default NoProfilesMessage;
